"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieCategory = void 0;
// create enum for cookie category
var CookieCategory;
(function (CookieCategory) {
    CookieCategory["StrictlyNecessary"] = "C0001";
    CookieCategory["Performance"] = "C0002";
    CookieCategory["Functional"] = "C0003";
    CookieCategory["Targeting"] = "C0004";
})(CookieCategory = exports.CookieCategory || (exports.CookieCategory = {}));
